import { LIGHTERXYZ_API_KEY, MALLARD_API_KEY } from '@funkit/api-base'

export function isMallardApiKey(apiKey: string): boolean {
  return apiKey === MALLARD_API_KEY
}

export function isLighterxyzApiKey(apiKey: string): boolean {
  return apiKey === LIGHTERXYZ_API_KEY
}
